import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from '@/App';
import '@/styles/globals.css';

const raiz = document.getElementById('raiz');

if (!raiz) {
  throw new Error('Elemento #raiz não encontrado no documento.');
}

// O tema é escolha explícita de quem visita, com claro por padrão. O script inline do
// `index.html` já o aplicou antes da primeira pintura; daqui em diante quem manda é o
// `useTema`, montado pelo alternador no cabeçalho.

createRoot(raiz).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
